export default [
  {
    title: 'Benvenuto',
    element: '.none',
    text: 'Benvenuto in {{wlName}}, la tua piattaforma di scambio di immagini mediche. In questo tour ti aiuteremo a iniziare ad usarlo.'
  },
  {
    title: 'Risultati medici',
    element: '.icons-layout',
    text: 'Qui puo vedere tutte le cartelle, i documenti e i test medici che sono stati condivisi con Lei.'
  },
  {
    title: 'Nessun risultato ancora',
    element: '.empty-folder',
    text: 'Sembra che i Suoi risultati non siano ancora stati caricati. Questo processo potrebbe richiedere diversi giorni.',
    placement: {
      relativeTo: 'element',
      position: 'right top'
    }
  },
  {
    title: 'Vedi i files',
    element: '.icon-wrapper-file',
    text: 'Puo fare <strong>clic</strong> per accedere alle cartelle o aprire i file.',
    placement: {
      relativeTo: 'element',
      position: 'right top'
    }
  }
]



// WEBPACK FOOTER //
// ./src/components/common/tour/tours/mobile/it-IT/guestTour.js